import TeamBuyingList from '@/data/teamBuying/view/list.vue'
import TeamBuyingEditor from '@/data/teamBuying/view/editor.vue'
import TeamBuyingProductList from '@/data/teamBuying/view/product-list.vue'
import TeamBuyingProductEditor from '@/data/product/view/editor.vue'
import TeamBuyingStatisticsView from '@/data/teamBuying/view/statistics.vue'

const list = {
  path: '/teamBuying',
  name: 'teamBuying-list',
  component: TeamBuyingList
}
const creator = {
  path: '/teamBuying/creator',
  name: 'createTeamBuying',
  component: TeamBuyingEditor
}
const editor = {
  path: '/teamBuying/editor/:id(\\d+)',
  name: 'updateTeamBuying',
  component: TeamBuyingEditor
}
const listOfProduct = {
  path: '/teamBuying/:teamBuyingID(\\d+)/products',
  name: 'teamBuying-product-list',
  component: TeamBuyingProductList
}
const creatorOfProduct = {
  path: '/teamBuying/:teamBuyingID(\\d+)/products/creator',
  name: 'createTeamBuyingProduct',
  component: TeamBuyingProductEditor
}
const editorOfProduct = {
  path: '/teamBuying/:teamBuyingID(\\d+)/products/editor/:id(\\d+)',
  name: 'updateTeamBuyingProduct',
  component: TeamBuyingProductEditor
}
const teamBuyingStatistics = {
  path: '/teamBuying-statistics',
  name: 'teamBuying-statistics',
  component: TeamBuyingStatisticsView
}

export default [list, creator, editor,
  listOfProduct, creatorOfProduct, editorOfProduct, teamBuyingStatistics]
